module.exports = __webpack_public_path__ + "img/correios.5f317e97.svg";